import { createClient } from "contentful";

const client = createClient({
    space: "et9ejp532o4t",
    accessToken: "mAlR558yMZqiOuLtRgNONsBBJpfG_sdWyyen6IpB_1w",
});

client.withAllLocales.getAssets().then((res) => {
    // console.log(res);
});
export default client;
